// extracted by mini-css-extract-plugin
module.exports = {"SectionPicture":"SectionPicture_SectionPicture__BLZM7"};